import { useFilters } from '@/components/analyticsPage/tabPanels/components/drawers/hooks/useFilters';
import { Checkbox } from '@/components/ui/checkbox';
import _ from 'lodash';

const Filters = ({ filters, setQuery, originalFilter = [] }) => {
  const [getFilters] = useFilters();

  const handleClick = (el) => {
    const result = getFilters(originalFilter, el);
    setQuery({ filters: result });
  };

  return (
    <>
      {filters?.map((el, i) => {
        if (el.category === 'Data-driven Materiality') {
          return null;
        }
        return (
          <div key={`filters_${i}`} className="space-y-1.5">
            <div className="flex items-center gap-2">
              <Checkbox
                checked={el.check}
                onClick={() => handleClick(el)}
                className="data-[state=checked]:bg-primary data-[state=checked]:border-primary border-primary"
              />
              {el.category}
            </div>
            <div className="ml-4">
              {el.subCategory ? (
                <Filters
                  filters={el.subCategory}
                  setQuery={setQuery}
                  originalFilter={originalFilter}
                />
              ) : null}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Filters;
